<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="ratesLos" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="rateLosId" selectionMode="single"
  [(selection)]="rateLos" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="250"
  [rowsPerPageOptions]="[250,500,1000, 2000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">RateLoss</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <!-- <th [ngStyle]="{'width': 'auto'}"></th> -->
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'rateLosId', 'in')"></th>
        <td><input pInputText style="min-width:150px;" type="datetime-local"
        (input)="pt.filter($event.target.value, 'createDate', 'in')"></td>
        <td><input pInputText style="min-width:150px;" type="datetime-local"
        (input)="pt.filter($event.target.value, 'lastUpdate', 'in')"></td>
        <td><input pInputText style="min-width:150px;" type="date"
        (input)="pt.filter($event.target.value, 'checkInDate', 'in')"></td>
        <td><input pInputText style="min-width:150px;" type="date"
        (input)="pt.filter($event.target.value, 'checkOutDate', 'in')"></td>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th>
        <!-- <th [ngStyle]="{'width': 'auto'}"></th> -->
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-rateLos>
    <tr [pSelectableRow]="rateLos">
      <td>{{rateLos.rateLosId}} </td>
      <td>{{rateLos.createDate}}</td>
      <td>{{rateLos.lastUpdate}}</td>
      <td>{{rateLos.checkInDate}}</td>
      <td>{{rateLos.checkOutDate}}</td>
      <td>{{rateLos.propertyCode}}</td>
      <!-- <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
        style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(rateLos)"></i>
      </a>
    </span>
  </td> -->
</tr>
</ng-template>
</p-table>